//loadBrandForMultipartners

import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, forkJoin, map, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';

import {
  SummariesAction,
  SummariesActionTypes
} from '@amfam/policy/data-access/lib/+state/summaries/summaries.actions';
import { selectUniquePartnerIds } from '@amfam/policy/data-access/lib/+state/summaries/summaries.selectors';

import { BrandService } from '../services/brand.service';
import {
  loadBrandsByIds,
  loadBrandsByIdsFailure,
  loadBrandsByIdsSuccess
} from './brand-multiple-partner.actions';

export const loading = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(SummariesActionTypes.SummariesLoadSuccessType),
      map((action: SummariesAction) => {
        return action.payload;
      }),
      filter(policySummaries => !!policySummaries?.length),
      mergeMap(payload => {
        return of(loadBrandsByIds(payload));
      })
    );
  },
  { functional: true }
);

export const loadBrandsByIds$ = createEffect(
  (actions$ = inject(Actions), brandService = inject(BrandService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(loadBrandsByIds),
      withLatestFrom(store.select(selectUniquePartnerIds)),
      switchMap(([, partnerIds]) => {
        const requests = partnerIds.map(id => brandService.loadBrandForMultipartners(id));

        return forkJoin(requests).pipe(
          map(brands => loadBrandsByIdsSuccess({ brands })),
          catchError(error => of(loadBrandsByIdsFailure({ error })))
        );
      })
    );
  },
  { functional: true }
);
